import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-99bff61a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "member-registration" }
const _hoisted_2 = {
  key: 0,
  class: "p-3"
}
const _hoisted_3 = {
  key: 0,
  role: "alert"
}
const _hoisted_4 = {
  key: 1,
  role: "alert"
}
const _hoisted_5 = ["src", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.invalidUrl || _ctx.returnError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.invalidUrl)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$gettext(
            "Unable to open the registration form. Please contact your administrator."
          )), 1))
            : _createCommentVNode("", true),
          (_ctx.returnError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$gettext("Unable to return to login. Please try again.")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.formSrc)
      ? (_openBlock(), _createElementBlock("iframe", {
          key: 1,
          ref: "membershipFrame",
          src: _ctx.formSrc,
          title: _ctx.$gettext('Sign-Up')
        }, null, 8, _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}